// Naduko — scripts propios (prefijo nk-)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initPacks();
  initFaq();
  initAlturaAnuncio();
  initAvisoNavegadorEmbebido();
  initJudgemeResenas(function () {
    initResenasMarquee();
  });
});

function initAvisoNavegadorEmbebido() {
  var aviso = document.querySelector('[data-nk-aviso-navegador]');
  if (!aviso) return;

  var ua = navigator.userAgent || '';
  var esEmbebido = /musical_ly|bytedance|tiktok/i.test(ua) ||
    /instagram/i.test(ua) ||
    /FBAN|FBAV|FB_IAB|FBSV/i.test(ua) ||
    /Line\//i.test(ua) ||
    /Snapchat/i.test(ua) ||
    /Pinterest/i.test(ua);
  if (!esEmbebido) return;

  aviso.hidden = false;
  document.documentElement.style.overflow = 'hidden';
}

function initAlturaAnuncio() {
  var barra = document.querySelector('.utility-bar');
  var header = document.querySelector('.section-header');
  if (!barra && !header) return;
  function medir() {
    if (barra) document.documentElement.style.setProperty('--nk-announce-height', barra.offsetHeight + 'px');
    if (header) document.documentElement.style.setProperty('--nk-header-height', header.offsetHeight + 'px');
  }
  medir();
  window.addEventListener('resize', medir);
}

function initReveal() {
  var els = document.querySelectorAll('.nk-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('nk-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nk-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var main = document.querySelector('[data-nk-galeria-principal]');
  var thumbs = document.querySelectorAll('[data-nk-galeria-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      main.src = full;
      thumbs.forEach(function (t) { t.classList.remove('nk-activo'); });
      thumb.classList.add('nk-activo');
    });
  });
}

function initPacks() {
  var dataEl = document.querySelector('[data-nk-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var packs = document.querySelectorAll('[data-nk-pack]');
  if (!packs.length) return;
  var addBtn = document.querySelector('[data-nk-add-btn]');
  var galeriaPrincipal = document.querySelector('[data-nk-galeria-principal]');
  var galeriaThumbs = document.querySelectorAll('[data-nk-galeria-thumb]');

  function variantePorColor(color) {
    return variantes.find(function (v) { return v.opciones['Color'] === color; });
  }

  function actualizarImagen(color) {
    var variante = variantePorColor(color);
    if (!variante || !variante.imagen) return;
    if (galeriaPrincipal) galeriaPrincipal.src = variante.imagen;
    galeriaThumbs.forEach(function (t) {
      t.classList.toggle('nk-activo', t.getAttribute('data-full') === variante.imagen);
    });
  }

  packs.forEach(function (pack) {
    var radio = pack.querySelector('[data-nk-pack-radio]');

    if (radio) {
      radio.addEventListener('change', function () {
        packs.forEach(function (p) { p.classList.remove('nk-pack-activo'); });
        pack.classList.add('nk-pack-activo');
      });
    }

    pack.querySelectorAll('[data-nk-pack-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var grupo = sw.closest('[data-nk-pack-color-picker]');
        grupo.querySelectorAll('.nk-activo').forEach(function (a) { a.classList.remove('nk-activo'); });
        sw.classList.add('nk-activo');
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
        actualizarImagen(sw.getAttribute('data-valor'));
      });
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var packActivo = document.querySelector('[data-nk-pack].nk-pack-activo') || packs[0];
      var items = [];
      var colorPickers = packActivo.querySelectorAll('[data-nk-pack-color-picker]');
      if (colorPickers.length) {
        colorPickers.forEach(function (picker) {
          var activo = picker.querySelector('.nk-activo');
          var color = activo ? activo.getAttribute('data-valor') : null;
          var variante = color ? variantePorColor(color) : variantes[0];
          if (variante) items.push({ id: variante.id, quantity: 1 });
        });
      } else {
        var qty = parseInt(packActivo.getAttribute('data-qty'), 10) || 1;
        items.push({ id: variantes[0].id, quantity: qty });
      }
      if (!items.length) return;
      var textoOriginal = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = addBtn.getAttribute('data-texto-agregando') || textoOriginal;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = textoOriginal;
        });
    });
  }
}

function initFaq() {
  var items = document.querySelectorAll('.nk-faq-item');
  if (!items.length) return;

  function cerrar(item) {
    var wrap = item.querySelector('.nk-faq-a-wrap');
    var q = item.querySelector('.nk-faq-q');
    item.classList.remove('nk-abierto');
    if (q) q.setAttribute('aria-expanded', 'false');
    if (wrap) wrap.style.maxHeight = '0px';
  }

  function abrir(item) {
    var wrap = item.querySelector('.nk-faq-a-wrap');
    var q = item.querySelector('.nk-faq-q');
    item.classList.add('nk-abierto');
    if (q) q.setAttribute('aria-expanded', 'true');
    if (wrap) wrap.style.maxHeight = wrap.scrollHeight + 'px';
  }

  items.forEach(function (item) {
    var q = item.querySelector('.nk-faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var abierto = item.classList.contains('nk-abierto');
      items.forEach(cerrar);
      if (!abierto) abrir(item);
    });
  });

  window.addEventListener('resize', function () {
    var abierto = document.querySelector('.nk-faq-item.nk-abierto');
    if (!abierto) return;
    var wrap = abierto.querySelector('.nk-faq-a-wrap');
    if (wrap) wrap.style.maxHeight = wrap.scrollHeight + 'px';
  });
}

function initJudgemeResenas(callback) {
  var fuente = document.querySelector('[data-nk-jdgm-fuente]');
  var track = document.querySelector('[data-nk-resenas-track]');
  if (!fuente || !track) {
    if (callback) callback();
    return;
  }

  // Judge.me inyecta las tarjetas (.jdgm-card) por JavaScript después de cargar la página,
  // así que reintentamos brevemente hasta que aparezcan (máx. ~5s) antes de darnos por vencidos.
  var intentos = 0;
  function intentar() {
    var tarjetas = fuente.querySelectorAll('.jdgm-card');
    intentos++;
    if (!tarjetas.length && intentos < 20) {
      setTimeout(intentar, 250);
      return;
    }
    poblarTarjetasResenas(fuente, track, tarjetas);
    if (callback) callback();
  }
  intentar();
}

function poblarTarjetasResenas(fuente, track, tarjetasNodeList) {
  var vistos = {};
  var tarjetas = Array.prototype.slice.call(tarjetasNodeList);

  tarjetas.forEach(function (tarjeta) {
    if (tarjeta.classList.contains('jdgm-clone-before') || tarjeta.classList.contains('jdgm-clone-after')) return;

    var idReview = tarjeta.getAttribute('data-review-id') || '';
    if (idReview && vistos[idReview]) return;
    if (idReview) vistos[idReview] = true;

    var textoEl = tarjeta.querySelector('.jdgm-text');
    var texto = textoEl ? textoEl.textContent.trim() : '';
    if (!texto) return;

    var estrellas = tarjeta.querySelectorAll('.jdgm-rating-section .jdgm-star.jdgm--on').length;
    if (!estrellas) estrellas = 5;

    var nombreCompleto = '';
    var nombreEl = tarjeta.querySelector('.jdgm-reviewer-name');
    if (nombreEl) nombreCompleto = nombreEl.textContent.trim();
    var primerNombre = nombreCompleto ? nombreCompleto.split(' ')[0] : 'Cliente verificado';

    var card = document.createElement('div');
    card.className = 'nk-resena-card';

    var starsDiv = document.createElement('div');
    starsDiv.className = 'nk-resena-stars';
    starsDiv.setAttribute('aria-hidden', 'true');
    var starsTxt = '';
    for (var i = 1; i <= 5; i++) { starsTxt += i <= estrellas ? '★' : '☆'; }
    starsDiv.textContent = starsTxt;

    var p = document.createElement('p');
    p.className = 'nk-resena-texto';
    p.textContent = '"' + texto + '"';

    var autorDiv = document.createElement('div');
    autorDiv.className = 'nk-resena-autor';
    var avatar = document.createElement('span');
    avatar.className = 'nk-resena-avatar';
    avatar.textContent = primerNombre.slice(0, 1);
    autorDiv.appendChild(avatar);
    autorDiv.appendChild(document.createTextNode(primerNombre));

    card.appendChild(starsDiv);
    card.appendChild(p);
    card.appendChild(autorDiv);
    track.appendChild(card);
  });

  if (!track.children.length) {
    var wrap = track.closest('.nk-resenas-track-wrap');
    if (wrap) wrap.style.display = 'none';
  }
}

function initResenasMarquee() {
  var track = document.querySelector('[data-nk-resenas-track]');
  if (!track) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var wrap = track.parentElement;
  var originalesCount = track.children.length;
  if (!originalesCount) return;
  var velocidad = 36; // px por segundo

  // Clona el set de tarjetas las veces que haga falta para que siempre
  // sobre contenido a la derecha, sin importar cuántas reseñas haya ni
  // el ancho de la pantalla — así nunca se ve un hueco en blanco al
  // reiniciar el ciclo del banner.
  function asegurarBuffer() {
    var minimo = (wrap.offsetWidth * 2) + 200;
    var intentos = 0;
    while ((track.scrollWidth < minimo || track.children.length <= originalesCount) && intentos < 12) {
      var base = Array.prototype.slice.call(track.children, 0, originalesCount);
      base.forEach(function (el) {
        var clon = el.cloneNode(true);
        clon.setAttribute('aria-hidden', 'true');
        clon.removeAttribute('data-shopify-editor-block');
        track.appendChild(clon);
      });
      intentos++;
    }
  }

  function recalcular() {
    asegurarBuffer();
    var primerClon = track.children[originalesCount];
    var distancia = primerClon ? primerClon.offsetLeft - track.children[0].offsetLeft : 0;
    if (distancia <= 0) return;
    track.classList.remove('nk-marquee-listo');
    track.style.setProperty('--nk-resenas-distancia', distancia + 'px');
    track.style.animationDuration = (distancia / velocidad) + 's';
    // eslint-disable-next-line no-unused-expressions
    track.offsetHeight; // fuerza reflow para reiniciar la animación desde 0 con la nueva distancia
    track.classList.add('nk-marquee-listo');
  }
  recalcular();
  window.addEventListener('resize', recalcular);
  window.addEventListener('load', recalcular);
}
